'use client';

import React, { useCallback, useMemo } from 'react';
import { Box, VStack } from '@skin-seoul/design-system';
import type { DropdownItem } from '@/components/ui/Dropdown/Dropdown';
import Dropdown from '@/components/ui/Dropdown/Dropdown';
import { ProductType, productSizeAndPackTextConverter, type ProductDetail, type VariableProductDetail } from '@skin-seoul/service';
import type { DropdownOptionStatus } from '@/components/ui/Dropdown/DropdownOption';
interface ProductOptionsSelectionProps {
  product: ProductDetail;
  selectedOption?: string;
  onOptionChange: (option: string) => void;
}
const ProductOptionsSelection = ({
  product,
  selectedOption,
  onOptionChange
}: ProductOptionsSelectionProps) => {
  const createDropdownItem = useCallback((item: {
    productId: string;
    status: string;
    size?: string;
    pack?: string;
    color?: string;
  }): DropdownItem => ({
    label: productSizeAndPackTextConverter(item) ?? '',
    value: item.productId,
    status: (selectedOption === item.productId && item.status !== 'outofstock' ? 'selected' : item.status) as DropdownOptionStatus
  }), [selectedOption]);
  const productOptions: DropdownItem[] = useMemo(() => {
    const items = product.type === ProductType.Variable ? (product as VariableProductDetail).variations : [product];
    return items.map(createDropdownItem);
  }, [product, createDropdownItem]);
  return <Box width="100%" background="white" borderBottom="1px solid" borderColor="neutral.50" paddingY={{
    base: 3,
    tablet: 6
  }} paddingX={{
    base: 4,
    tablet: 4
  }} data-sentry-element="Box" data-sentry-component="ProductOptionsSelection" data-sentry-source-file="ProductOptionsSelection.tsx">
      <VStack gap={6} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="ProductOptionsSelection.tsx">
        <Dropdown items={productOptions} selectedValue={selectedOption} onValueChange={onOptionChange} label="Options" data-sentry-element="Dropdown" data-sentry-source-file="ProductOptionsSelection.tsx" />
      </VStack>
    </Box>;
};
export default ProductOptionsSelection;